"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECardStateGame = void 0;
var ECardStateGame;
(function (ECardStateGame) {
    ECardStateGame[ECardStateGame["NO_CARDS_CHOOSABLE"] = 0] = "NO_CARDS_CHOOSABLE";
    ECardStateGame[ECardStateGame["CARDS_CHOOSABLE"] = 1] = "CARDS_CHOOSABLE";
    ECardStateGame[ECardStateGame["CARDS_CHOSEN"] = 2] = "CARDS_CHOSEN";
})(ECardStateGame || (ECardStateGame = {}));
exports.ECardStateGame = ECardStateGame;
